type HomePageValuationModalValues =
  | {
      mileage: string;
      mileageType: string;
      registration: string;
      make?: string;
      model: string;
      year: string;
      trim: string;
      bodyType: string;
      fuelType: string;
      transmission: string;
      valuation: {
        min: number;
        max: number;
      };
    }
  | undefined;

export enum HOMEPAGE_VALUATION_LOOKUP {
  KEY = 'HomepageValuationData',
}

export type { HomePageValuationModalValues };
